import { helperConstants as constants } from "../helpers/helperConstants";

export const getCdnUrl = (
  path = "",
  imagesize: string | number = "detail",
  updatedAt?: any
) => {
  if (path && (path.includes("http") || path.includes("https"))) return path;
  // return constants.cdn.path + path + constants.cdn[imagesize] + constants.cdn.version;
  return (
    constants.cdn.path +
    path +
    (constants.cdn[imagesize] || `?tr=w-${imagesize}`) +
    constants.cdn.version +
    (updatedAt ? "&dua=" + updatedAt.split("T")[0].split("-").join("") : "")
  );
};
